<template>
  <div class="pay">
    <div class="pay-content">
      <img class="pay-img" :src="imgSrc" alt="" v-if="showCode" />
      <img class="pay-success" src="@/assets/pay-success.png" alt="" srcset="" v-if="!showCode" />
      <h2 v-if="!showCode">{{ "Thanh toán thành công" }}</h2>
      <div class="pay-btn">
        <el-button type="primary" style="
            width: 100%;
            height: 100%;
            background: rgba(17, 136, 255);
            border-color: transparent;
          " @click="handleBack()">BACK</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      showCode: true,
      imgSrc: "",
      order_no: "",
      type: "",
      time: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    this.imgSrc = this.$route.query.redirect_url;
    this.order_no = this.$route.query.order_no;
    this.type = this.$route.query.type;
    // this.time = setInterval(() => {
    //   this.getPayOrderInfo();
    // }, 5000);

    // setTimeout(() => {
    //   clearInterval(this.time);
    // }, 5000 * 12 * 5);
  },
  mounted() { },
  methods: {
    getPayOrderInfo() {
      let params = {
        order_no: this.order_no,
        type: this.type,
      };
      this.$http.get("/pay/orderInfo", { params }).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data.status === 1) {
            // this.$router.push("/consume");
            if (this.time) {
              clearInterval(this.time);
            }
            this.showCode = false;
            this.$message.success(res.data.msg);
          }
        } else {
          if (this.time) {
            clearInterval(this.time);
          }
          this.$message.error(res.data.msg);
        }
      });
    },
    handleBack() {
      if (this.time) {
        clearInterval(this.time);
      }
      this.$router.go(-1)
    },
  },
};
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
}

.pay {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pay-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.pay-img {
  width: 80%;
}

.pay-success {
  width: 250px;
}

.pay-btn {
  width: 80%;
  height: 30px;
}

h2 {
  margin: 48px 0;
}

@media screen and (max-width: 1000px) {}
</style>
